<template>
  <div class="item-box">
    <b-row>
      <b-col class="item-btn" @click="expand">
        <span>
          <span
            v-if="!isExpand"
            class="item-btn"
            :class="{ disabled: isAllHoseholds }"
          >
            <icon name="plus" class="fold-icon"></icon>
          </span>
          <span
            v-if="isExpand"
            class="item-btn"
            :class="{ disabled: isAllHoseholds }"
          >
            <icon name="minus" class="fold-icon"></icon>
          </span>
        </span>
        <span class="type-link" :class="{ disabled: isAllHoseholds }">{{ category.desc }}</span>
      </b-col>
    </b-row>
    <m-loader size="before" :show="!hasLoad" />
    <div v-if="isExpand">
      <m-demo-select-item
        v-for="item in columns"
        :isClose="false"
        :item="item"
        :demoType="category.demoType"
        :specialDemoCategory="specialDemoCategory"
        :key="item.ColumnName"
        :deep="1"
      />
    </div>
  </div>
</template>
  
<script>
import notification from "@/components/common/notification";
import MDemoAllCheck from "@/components/demo/MDemoAllCheck";
import MDemoSelectItem from "@/components/demo/MDemoSelectItem";
export default {
  props: {
    category: {
      type: Object,
    },
    specialDemoCategory: {
      type: [Number, Boolean],
      default: false,
    },
  },
  components: {
    MDemoAllCheck,
    MDemoSelectItem,
  },
  data() {
    return {
      isExpand: false,
      hasLoad: true,
    };
  },
  computed: {
    listType() {
      if (this.$store.state.order.ListType) {
        return this.$store.state.order.ListType;
      } else {
        return 10;
      }
    },
    demos() {
      return this.$store.state.demo.demos;
    },
    columns() {
      if (
        this.listType in this.demos &&
        this.category.demoType in this.demos[this.listType]
      ) {
        return this.demos[this.listType][this.category.demoType];
      } else {
        this.getDemos();
        return [];
      }
    },
    isAllHoseholds() {
      return this.$store.getters["order/isAllHoseholds"];
    },
  },
  created() {},
  methods: {
    getDemos() {
      this.hasLoad = false;
      this.$http
        .post("PlaceOrder.aspx/GetDemoAttributesList", {
          demotype: this.category.demoType,
          listtype: this.listType,
        })
        .then((resp) => {
          let data = resp.body.d.DataSource;
          this.$store.commit("demo/saveColumns", {
            listType: this.listType,
            demoType: this.category.demoType,
            data,
          });
          this.hasLoad = true;
        });
    },
    expand() {
      if (!this.isAllHoseholds) this.isExpand = !this.isExpand;
    },
  },
};
</script>
  
<style scoped lang="scss">
.h3-t {
  color: $color-black;
  margin-top: 8px;
}

.demos-column.demos-value {
  color: $color-black;
  margin-left: 0;
  /* TODO@PONY no unifrom css */
  font-size: 0.9em;
}

.demos-value {
  margin-left: 16px;
}

.select-demo-col {
  padding: 0 8px;
}

.box {
  padding-left: 8px;
  padding-right: 8px;
  display: block;
}

.input-box {
  display: block;
  width: 100%;
  height: 230px;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: $color-background;
  background-image: none;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

.input-box-input {
  margin-top: -8px;
  margin-bottom: 8px;
}

.m-error-text {
  font-size: 12px;
  font-weight: normal;
}

.right-select {
  text-align: right;
}

.mt-title {
  margin-top: 0.9rem !important;
}

.lable-name {
  margin-bottom: 0px;
}

.add-btn {
  margin: 8px;
}

.add-p {
  margin: 4px;
}

</style>
  


// WEBPACK FOOTER //
// src/components/demo/MDemoSelectType.vue